import * as React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { de } from "date-fns/locale";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter, HashRouter } from "react-router-dom";
import DateFnsUtils from "material-ui-pickers/utils/date-fns-utils";
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";

import CssBaseline from "@material-ui/core/CssBaseline";

import { store } from "./store/index";
import { i18n } from "./i18n/index";
import { ConnectedRoot } from "./components/root";
import { theme } from "./theme";

export const App = (
	<Provider store={store}>
		<I18nextProvider i18n={i18n}>
			<MuiPickersUtilsProvider utils={DateFnsUtils} locale={de}>
				<MuiThemeProvider theme={theme}>
					<CssBaseline />
					<HashRouter>
						<ConnectedRoot />
					</HashRouter>
				</MuiThemeProvider>
			</MuiPickersUtilsProvider>
		</I18nextProvider>
	</Provider>
);
